import { useParams, useSearchParams } from 'react-router-dom';

import { AcceptInvitationPage } from '~/components/pages/AcceptInvitationPage';
import { PageTemplate } from '~/components/templates/PageTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AcceptInvitationRoute: React.FC = () => {
  const { organizationId, invitationId } = useParams();
  const [searchParams] = useSearchParams();
  const challengeCode = searchParams.get('challengeCode');

  if (!organizationId || !invitationId || !challengeCode) {
    return <Navigate to="/" replace />;
  }

  return (
    <PageTemplate>
      <AcceptInvitationPage
        organizationId={organizationId}
        invitationId={invitationId}
        challengeCode={challengeCode}
      />
    </PageTemplate>
  );
};
